import { Avatar, Text, Tooltip } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { Facilitator } from '.';
import { ApiService } from '../../../constants';
import { HttpService } from '../../../utilities';

interface FacilitatorItemProps extends Facilitator {
  type?: 'default' | 'more';
  onClick?: () => void;
  total?: number;
}

const FacilitatorItem: React.FC<FacilitatorItemProps> = ({
  email,
  facilitatorname,
  urlprofile,
  onClick,
  total,
  type = 'default'
}) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>();
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadProfileImage = async () => {
      setImageUrl(undefined);
      setImageError(false);

      if (!urlprofile?.trim()) return;

      try {
        const response = await HttpService.get<string>(
          ApiService.beelajar.getImageMoodle(urlprofile)
        );

        if (cancelled) return;

        const result = response?.data;

        if (
          typeof result === 'string' &&
          /^https?:\/\//i.test(result.trim())
        ) {
          setImageUrl(result.trim());
        } else {
          setImageError(true);
        }
      } catch (error) {
        console.error('Failed to load facilitator image:', error);

        if (!cancelled) {
          setImageError(true);
        }
      }
    };

    loadProfileImage();

    return () => {
      cancelled = true;
    };
  }, [urlprofile]);

  if (type === 'more') {
    return (
      <Tooltip label="More" withArrow>
        <span onClick={onClick} style={{ cursor: 'pointer' }}>
          <Avatar
            alt="More Facilitator"
            color="#7B2183"
            bg="#F7DFF9"
            radius="xl"
          >
            <Text fz={12} fw={700}>
              +{total}
            </Text>
          </Avatar>
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip label={facilitatorname} withArrow>
      <Avatar
        alt={email}
        src={imageError ? undefined : imageUrl}
        radius="xl"
        onError={() => setImageError(true)}
      />
    </Tooltip>
  );
};

export default FacilitatorItem;